import api from './api';

export async function fetchMeetingConfig() {
  const response = await api.get('/api/meetings/config');
  return response.data;
}

export async function fetchMeetingTemplates() {
  const response = await api.get('/api/meetings/templates');
  return response.data;
}

export async function createMeetingSession(payload) {
  const response = await api.post('/api/meetings/sessions', payload);
  return response.data;
}

export async function uploadMeetingAudio(sessionId, file, onProgress) {
  const formData = new FormData();
  formData.append('file', file);
  const response = await api.post(`/api/meetings/sessions/${sessionId}/upload`, formData, {
    transformRequest: (data, headers) => {
      if (headers) {
        delete headers['Content-Type'];
      }
      return data;
    },
    onUploadProgress: (progressEvent) => {
      if (!onProgress) return;
      const percent = progressEvent.total
        ? Math.round((progressEvent.loaded * 100) / progressEvent.total)
        : 0;
      onProgress(percent);
    },
  });
  return response.data;
}

export async function finalizeMeetingSession(sessionId, payload) {
  const response = await api.post(`/api/meetings/sessions/${sessionId}/finalize`, payload);
  return response.data;
}

export async function fetchMeetingSession(sessionId) {
  const response = await api.get(`/api/meetings/sessions/${sessionId}`);
  return response.data;
}

export async function fetchMeetingChatHistory(sessionId) {
  const response = await api.get(`/api/meetings/sessions/${sessionId}/chat`);
  return response.data;
}

export async function identifyMeetingSpeakers(sessionId, contextHint = '') {
  const response = await api.post(`/api/meetings/sessions/${sessionId}/identify-speakers`, {
    context: contextHint,
  });
  return response.data;
}

export async function updateMeetingAttendees(sessionId, attendees) {
  const response = await api.put(`/api/meetings/sessions/${sessionId}/attendees`, {
    attendees,
  });
  return response.data;
}

export async function chatAboutMeeting(sessionId, question) {
  const response = await api.post(`/api/meetings/sessions/${sessionId}/chat`, {
    question,
  });
  return response.data;
}

export async function listMeetingSessions() {
  const response = await api.get('/api/meetings/sessions');
  return response.data;
}

export function downloadMeetingArtifact(sessionId, artifact) {
  const url = `/api/meetings/sessions/${sessionId}/download?artifact=${artifact}`;
  window.open(url, '_blank');
}

export async function renameMeetingSpeakers(sessionId, mapping, regenerateSummary = false) {
  const response = await api.patch(`/api/meetings/sessions/${sessionId}/speakers`, {
    mapping,
    regenerate_summary: regenerateSummary,
  });
  return response.data;
}

export async function uploadTextSession(payload) {
  const response = await api.post('/api/meetings/sessions/upload-text', payload);
  return response.data;
}

export async function regenerateMeetingSummary(sessionId, customInstructions) {
  const response = await api.post(`/api/meetings/sessions/${sessionId}/regenerate`, {
    custom_instructions: customInstructions,
  });
  return response.data;
}

export async function resetMeetingSummary(sessionId, overrides = {}) {
  const response = await api.post(`/api/meetings/sessions/${sessionId}/reset`, overrides);
  return response.data;
}

export async function deleteRefinementStep(sessionId, stepId) {
  const response = await api.delete(`/api/meetings/sessions/${sessionId}/refinements/${stepId}`);
  return response.data;
}

export async function unpublishMeetingSession(sessionId) {
  const response = await api.post(`/api/meetings/sessions/${sessionId}/unpublish`);
  return response.data;
}

export async function publishMeetingSession(sessionId) {
  const response = await api.post(`/api/meetings/sessions/${sessionId}/publish`);
  return response.data;
}
